<template>
  <avatar
    :color="
      avatarUrl
        ? 'transparent'
        : color || getColor($vuetify.theme.themes.light.secondarytext, 0.1)
    "
    :avatarUrl="avatarUrl"
    :name="name"
    :cssClass="cssClass"
    :size="size"
    :borderColor="borderColor"
    :textColor="textColor"
    v-on:click="$emit('click')"
  >
    <template v-slot:tooltip v-if="toolTipText">
      {{ toolTipText }}
    </template>
  </avatar>
</template>

<script>
export default {
  name: "UserAvatar",
  components: {},
  props: {
    color: {
      type: String,
      default: ""
    },
    user: { type: Object },
    cssClass: {
      type: String,
      default: ""
    },
    size: {
      type: [Number, String],
      default: 20
    },
    borderColor: {
      type: String,
      default: ""
    },
    textColor: { type: String, default: "secondarytext" },
    toolTipText: { type: String }
  },
  computed: {
    name() {
      return (this.user || {}).fullName;
    },
    avatarUrl() {
      return (this.user || {}).avatarUrl || this.badgeUrl;
    },
    badgeUrl() {
      return this.isManager
        ? this.$images.AVATAR_MANAGER
        : this.$images.AVATAR_MEMBER;
    },
    isManager() {
      if ((this.user || {}).isManager) {
        return true;
      }
      return (
        (this.user || {}).systemRoleId != this.$enums.systemRoleTypes.MEMBER
      );
    }
  }
};
</script>
